import React                  from 'react';
import { PostLayoutHandbook } from './post-layout';

const PostLayout = (props) => <PostLayoutHandbook title="Primary Programme Guide" url="/handbook/primary/" { ...props } />;

export default PostLayout;
